module.exports = __webpack_public_path__ + "img/star-vip-icon.ef9342e2.svg";